export default "__VITE_ASSET__2b208f5c__"